import React, {useCallback, useEffect, useState} from 'react';
import {SizeList} from "../../../../components/admin/equipment/SizeList";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {sizeResultCollectionType, sizeResultType} from "../../../../types/Api/SizeResultType";
import {sizeHydrator} from "../../../../models/hydrator/sizeHydrator";
import {size} from "../../../../models/size";
import {Pagination} from "../../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Tab} from "../../../../components/admin/equipment/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sizes, setSizes] = useState([] as size[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findSize = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'order',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<sizeResultCollectionType> = ApiService.get('/size', apiFilters) as Promise<sizeResultCollectionType>;

    result
      .then((r: sizeResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setSizes(r._embedded.sizes.map((size: sizeResultType) => {
          return sizeHydrator.hydrate(size);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setSizes([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findSize();
  }, [findSize]);

  return (
    <>
      <BoxTitle title="Gestion de l'équipement"/>
      <Tab/>
      <SizeList sizes={sizes} loading={loading} refresh={findSize}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 d-flex justify-content-between">
        <NavLink to={`/admin/equipment/size/order`} onClick={scrollTo} className="btn btn-sm btn-info">
          <i className="fa-solid fa-shuffle me-1"/> Modifier l'ordre
        </NavLink>

        <NavLink to={`/admin/equipment/size/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter une taille
        </NavLink>
      </div>
    </>
  )
}